//ici la page ou on va presenter les projet  et on affiche le chargement avent l'affichahge des projets avec FetchData et le comfirmer avec le backend et on affiche
//les projets avec la map

import React, { useState, useEffect } from "react";
import "./projet.css";
import loadingImage from "../../assets/images/disque.png";
import { Link } from "react-router-dom";
import { API_ROUTES } from "../../utils/constant";
import axios from "axios";

const Projets = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [projets, setProjets] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(API_ROUTES.PROJETS);
        console.log("API Response: ", response.data); // Log the entire response
        setProjets(response.data);
        setIsLoading(false);
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchData();
  }, []);

  const currentTheme = localStorage.getItem("theme");

  useEffect(() => {
    const projetSelectElement = document.querySelector(".projets");

    if (projetSelectElement) {
      if (currentTheme === "light") {
        projetSelectElement.classList.remove("dark-mode-details");
        projetSelectElement.classList.add("light-mode-details");
      } else {
        projetSelectElement.classList.remove("light-mode-details");
        projetSelectElement.classList.add("dark-mode-details");
      }
    }
  }, [currentTheme]);

  // Fonction utilitaire pour générer le texte alt
  const generateAltText = (projet) => {
    return `Image du projet ${projet.title}`;
  };

  return (
    <div className="projets">
      <div className="projets-container">
        {isLoading ? (
          <div className="loading">
            <img
              src={loadingImage}
              alt="Loading"
              className="loading-image rotating"
            />
            <p>Chargement...</p>
          </div>
        ) : (
          <>
            <h2 className="titre">Mes projets</h2>
            <div className="projets-list">
              {Array.isArray(projets) && projets.map((projet) => {
                console.log("Image URL: ", projet.image);  // Log the image URL to debug
                return (
                  <div className="projet" key={projet._id}>
                    <Link to={`/projetdetail/${projet._id}`}>
                      <img
                        src={projet.image}
                        alt={generateAltText(projet)}
                        width="300"
                        height="200"
                        onError={(e) => e.target.src = 'https://via.placeholder.com/300x200'}
                      />
                      <h3>{projet.title}</h3>
                    </Link>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Projets;
